import Axios from 'axios'
import {causeUrls} from '../urls'
import router from '../../../router'

export default {
  get_all_causes (context) {
    Axios.get(causeUrls.getAllCauses).then(function (response) {
      context.commit('GET_ALL_CAUSES', response.data)
    })
  },
  get_causes (context, publicId) {
    Axios.get(causeUrls.getCauses + publicId).then(function (response) {
      context.commit('GET_CAUSES', response.data)
    })
  },
  get_deleted_causes (context) {
    Axios.get(causeUrls.getDeletedCause).then(function (response) {
      context.commit('GET_DELETED_CAUSES', response.data)
    })
  },
  get_cause (context, publicId) {
    Axios.get(causeUrls.getCause + publicId).then(function (response) {
      context.commit('GET_CAUSE', response.data)
    })
  },
  post_cause (context, data) {
    Axios.post(causeUrls.postCause, data).then(function () {
      context.dispatch('get_all_causes')
      router.push({
        name: data.redirect_url
      })
    }).catch(function (error) {
      context.commit('UPDATE_ERRORS', error.data)
    })
  },
  update_cause (context, data) {
    Axios.post(causeUrls.editCause, data).then(function () {
      context.dispatch('get_all_causes')
      router.push({
        name: data.redirect_url
      })
    }).catch(function (error) {
      context.commit('UPDATE_ERRORS', error.data)
      
    })
  },
  delete_cause (context, publicId) {
    let data = {
      public_id: publicId
    }
    Axios.patch(causeUrls.deleteCause, data).then(function (response) {
      context.dispatch('get_all_causes')
      router.push({
        name: data.redirect_url
      })
    })
  },
  restoreCause (context, publicId) {
    Axios.get(causeUrls.restoreCause + publicId).then(function (response) {
      alert(response.data.message)
      context.commit('GET_ALL_CAUSES', response.data)
      router.push({
        name: 'Module.Causes'
      })
    })
  }
}
